











import { defineComponent, ref, watch, computed } from '~/utils/nuxt3-migration'

export default defineComponent({
  inheritAttrs: true,
  components: {
    VCalendarDatepicker: () =>
      import('v-calendar/lib/components/date-picker.umd')
  },
  setup(_props, { emit }) {
    const calendarRef = ref()

    const masks = computed(() => ({
      weekdays: 'WWW'
    }))

    const attributes = computed(() => [
      {
        key: 'today',
        highlight: {
          contentClass: 'current-date'
        },
        dates: new Date()
      }
    ])

    watch(calendarRef, newCalendarRef => {
      if (newCalendarRef) {
        emit('show')
      }
    })

    function focusDate(date: Date) {
      calendarRef.value.focusDate(date)
    }

    return { calendarRef, focusDate, masks, attributes }
  }
})
